import { render } from "./AnakinHeaderButton.vue?vue&type=template&id=b527b72c&ts=true"
import script from "./AnakinHeaderButton.vue?vue&type=script&lang=ts"
export * from "./AnakinHeaderButton.vue?vue&type=script&lang=ts"

import "./AnakinHeaderButton.vue?vue&type=style&index=0&id=b527b72c&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__